import { inject } from '@angular/core';
import { environment } from '@shared-app-config';
import { AuthDialogContext, AuthService } from '@feature-auth';

export interface LandingActions {
  openCarrierCabinet(): void;
  openCustomerCabinet(): void;
  scrollToAnchor(anchor: string): void;
  openAuthDialog(context: AuthDialogContext): Promise<void>;
}

/** The calls to action shared by the landing pages. Call it in an injection context. */
export function injectLandingActions(): LandingActions {
  const authService = inject(AuthService);

  return {
    openCarrierCabinet: () => {
      window.location.href = `${environment.frontendUrl.carrier}/authorization`;
    },
    openCustomerCabinet: () => {
      window.location.href = `${environment.frontendUrl.customer}/authorization`;
    },
    scrollToAnchor: (anchor: string) => {
      document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    openAuthDialog: (context: AuthDialogContext) => authService.authenticate(context),
  };
}
